import {
	_t,
	barkApi,
	bugsnagClientNotify,
    tracking as barkTrackingLogEvent
} from '@bark/bark-core';
import moment from 'moment';

export default function (activityLog = null) {
	const { Handlebars, Bark } = window;

	const state = {
        projectResponseActionId: ''
	};

	const domElements = {
		modalId: 'call-reminder-modal',
		modalContainerId: 'call-reminder-modal-container',
	};

	const hbTemplates = {
		modalTemplate: Handlebars.compile(
			document.getElementById('call-reminder-modal-template').innerHTML,
		),
	};

	const show = (projectResponseActionId) => {
        state.projectResponseActionId = projectResponseActionId;
        buildModal();
        bindListeners();

        callReminderLogTrackingEvent('call_reminder - create_reminder_view', state);

		$(`#${domElements.modalId}`).modal('show');
	};

    const showFromActivityLog = (projectResponseActionId) => {
        state.projectResponseActionId = projectResponseActionId;
        buildModal();
        bindListeners();

        callReminderLogTrackingEvent('call_reminder - create_reminder_view', state);

        $(`#${domElements.modalId}`).modal('show');
    };

    const showEdit = (reminderId, triggerAt) => {
        const dateTime = moment.utc(triggerAt).local().toDate();
        buildModal(reminderId, dateTime, true);
        bindEditListeners();

        callReminderLogTrackingEvent(
            'call_reminder - edit_reminder_CTA',
            {
                reminderId: reminderId
            }
        );

        $(`#${domElements.modalId}`).modal('show');
        callReminderLogTrackingEvent('call_reminder - create_reminder_view');
    };

	const buildModal = (reminderId = null, initialDate = new Date(), isEditModal = false) => {
		$(`#${domElements.modalContainerId}`).empty();
		let setReminderTitle = _t('seller_common:call-reminder-modal.call-reminder-title');
		if (isEditModal) {
		    setReminderTitle = _t('seller_common:call-reminder-modal.call-reminder-edit-title');
        }
		const html = hbTemplates.modalTemplate({
			text: {
				setReminder: setReminderTitle,
                setReminderDescription: _t('seller_common:call-reminder-modal.call-reminder-description'),
                reminderOneHour: _t('seller_common:call-reminder-modal.reminder-hour-option'),
                reminderFourHours: _t('seller_common:call-reminder-modal.reminder-four-hours-option'),
                reminderTomorrow: _t('seller_common:call-reminder-modal.reminder-tomorrow-option'),
                createReminder: _t('seller_common:call-reminder-modal.submit-button')
			},
		});
		$(`#${domElements.modalContainerId}`).append(html);

        let dd = initialDate.getDate();
        let mm = initialDate.getMonth()+1; //January is 0!
        const yyyy = initialDate.getFullYear();
        if (!isEditModal) {
            initialDate.setHours(initialDate.getHours() + 1);
        }
        let hh = initialDate.getHours();
        let mins = initialDate.getMinutes();
        if (dd<10) {
            dd = String(dd).padStart(2,'0');
        }
        if (mm<10) {
            mm = String(mm).padStart(2,'0');
        }
        if (hh<10) {
            hh = String(hh).padStart(2,'0');
        }
        if (mins<10) {
            mins = String(mins).padStart(2,'0');
        }

        const dateString = yyyy + '-' + mm + '-' + dd;
        const timeString = hh + ':' + mins;

        const dayDate = Bark.getHtml('input', null, null, 'bark-date no-pikaday w-100 form-control px-3', {
            type: 'date',
            placeholder: '',
            'tab-index': 1,
            value: dateString,
            id: "reminder-date"
        });
        const timeDate = Bark.getHtml('input', null, null, 'bark-date-time w-100 form-control px-3', {
            type: 'time',
            placeholder: '',
            'tab-index': 2,
            value: timeString,
            id: 'reminder-datetime'
        });


        $('#reminder-calender-picker').html(dayDate);
        $('#reminder-timedate-picker').html(timeDate);
        if (isEditModal) {
            $(".time-duration-container .js-time-duration").each(function() {
                $(this).removeClass('active-td');
            });
        }

        if(reminderId) {
            $('#reminder-id').val(reminderId)
        }
	};

	const bindListeners = () => {

        reminderTimePeriodButtonListener();

        $(`#${domElements.modalId}` + ' #create-reminder')
            .off('click')
            .on('click', function (e) {
                 const date = $('#reminder-date').val();
                 const time = $('#reminder-datetime').val();
                 createReminder(date, time);
            });
	};

    const bindEditListeners = () => {

        reminderTimePeriodButtonListener();

        $(`#${domElements.modalId}` + ' #create-reminder')
            .off('click')
            .on('click', function (e) {
                const date = $('#reminder-date').val();
                const time = $('#reminder-datetime').val();
                const reminderId = $('#reminder-id').val();
                editReminder(date, time, reminderId);
            });
    };

    const bindActivityLogListeners = (activityLog) => {

        activityLog.getContainer().off('click.editReminder').on('click.editReminder', '.edit-reminder', (e) => {
            e.preventDefault();
            showEdit($(e.currentTarget).data('reminder-id'), $(e.currentTarget).data('trigger-at'));
        });

        activityLog.getContainer().off('click.removeReminder').on('click.removeReminder', '.remove-reminder', (e) => {
            e.preventDefault();
            removeReminder($(e.currentTarget).data('reminder-id'), e);
        });

        activityLog.getContainer().off('click.createReminder').on('click.createReminder', '.create-reminder', (e) => {
            e.preventDefault();
            showFromActivityLog($(e.currentTarget).data('project-response-action-id'));
        });
    };

    const reminderTimePeriodButtonListener = () => {
        $(`#${domElements.modalId}` + ' .js-time-duration')
            .off('click')
            .on('click', function (e) {
                $(".time-duration-container .js-time-duration").each(function() {
                    $(this).removeClass('active-td');
                });

                $(this).addClass('active-td');
                //add time to form
                let today = new Date();

                if ($(this).data('time-d') < 24) {
                    today.setHours(today.getHours() + $(this).data('time-d'));
                } else {
                    today.setDate(today.getDate() + 1);
                }

                let dd = today.getDate();
                let mm = today.getMonth() + 1;
                const yyyy = today.getFullYear();
                let hh = today.getHours();
                let mins = today.getMinutes();

                if (dd<10) {
                    dd = String(dd).padStart(2,'0');
                }
                if (mm<10) {
                    mm = String(mm).padStart(2,'0');
                }
                if (hh<10) {
                    hh = String(hh).padStart(2,'0');
                }
                if (mins<10) {
                    mins = String(mins).padStart(2,'0');
                }

                $('#reminder-date').val(yyyy + '-' + mm + '-' + dd);
                $('#reminder-datetime').val(hh + ':' + mins);

                if (validateDateAndTime()) {
                    const dateTime = getDateObjectFromDateAndTime($('#reminder-date').val(), $('#reminder-datetime').val())
                    $(`#${domElements.modalId} .error-div`).addClass('d-none');
                    $('#create-reminder').prop('disabled', false);
                    callReminderLogTrackingEvent('call_reminder - reminder_quick', {
                        time_to_reminder: durationFromNowAsString(moment($('#reminder-date').val() + " " + $('#reminder-datetime').val()).utc())
                    });
                }
            });

        $(`#${domElements.modalId}` + ' #reminder-date')
            .off('change')
            .on('change', function (e) {
                if (validateDateAndTime()) {
                    const dateTime = getDateObjectFromDateAndTime($('#reminder-date').val(), $('#reminder-datetime').val());
                    $(".time-duration-container .js-time-duration").each(function() {
                        $(this).removeClass('active-td');
                    });
                }
            });

        $(`#${domElements.modalId}`+' .close-modal-cross')
            .off('click')
            .on('click', function (e) {
                callReminderLogTrackingEvent('call_reminder - reminder_modal_closed', state);
            });

        $(`#${domElements.modalId}` + ' #reminder-datetime')
            .off('change')
            .on('change', function (e) {
                if (validateDateAndTime()) {
                    $(".time-duration-container .js-time-duration").each(function() {
                        $(this).removeClass('active-td');
                    });
                }
            });

        $(`#${domElements.modalId} #reminder-date`)
            .off('click')
            .on('click', function (e) {
                callReminderLogTrackingEvent('call_reminder - reminder_calendar_view_date');
            });
        $(`#${domElements.modalId} #reminder-datetime`)
            .off('click')
            .on('click', function (e) {
                callReminderLogTrackingEvent('call_reminder - reminder_calendar_view_time');
            });
    }

    const editReminder = (date, time, reminderId) => {
        clearErrorState()
        if (validateDateAndTime()) {
            const dateTime = getDateObjectFromDateAndTime(date, time)
            barkApi(
                'reminders/' + reminderId,
                {
                    trigger_at: moment(dateTime).utc().format('YYYY-MM-DD HH:mm:ss'),
                    notifications: ['email']
                },
                (res) => {
                    $(`#${domElements.modalId}`).modal('hide');

                    if (activityLog) {
                        setTimeout(() => {
                            activityLog.redraw();
                        }, 1000);
                    }
                    callReminderLogTrackingEvent('call_reminder - reminder_edit', {
                        time_to_reminder: durationFromNowAsString(moment(date + " " + time).utc())
                    });
                },
                (error) => {
                    setFormToErrorState(_t('seller_common:call-reminder-modal.error.cant-update'), false)
                    bugsnagClientNotify('Failed to update reminder', error);
                },
                'PUT',
            );
        }
    };

    const removeReminder = (reminderId, event) => {
        if (window.confirm(_t('seller_common:call-reminder-modal.remove-confirm'))) {
            barkApi(
                'reminders/' + reminderId,
                {},
                (res) => {
                    $(`#${domElements.modalId}`).modal('hide');

                    if (activityLog) {
                        setTimeout(() => {
                            activityLog.redraw();
                        }, 1000);
                    }
                    callReminderLogTrackingEvent('call_reminder - reminder_remove', state);
                },
                (error) => {
                    window.alert(_t('seller_common:call-reminder-modal.error.cant-delete'))
                    bugsnagClientNotify('Failed to delete reminder', error);
                },
                'DELETE',
            );
        } else {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    };

    const validateDateAndTime = () => {
        const dateValue = $('#reminder-date').val();
        const timeValue = $('#reminder-datetime').val();
        if (dateValue == '') {
            setFormToErrorState(_t('seller_common:call-reminder-modal.error.time-invalid'));
            return false;
        }
        if (timeValue == '') {
            setFormToErrorState(_t('seller_common:call-reminder-modal.error.invalid-datetime'));
            return false;
        }
        const dateTime = getDateObjectFromDateAndTime(dateValue, timeValue);
        const now = new Date();
        if( !(dateTime instanceof Date) ) {
            setFormToErrorState(_t('seller_common:call-reminder-modal.error.invalid-datetime'));
            return false;
        }
        if (now > dateTime) {
            setFormToErrorState(_t('seller_common:call-reminder-modal.error.datetime-past'));
            return false;
        }
        if (dateTime > new Date('2038-01-19 00:00')) {
            setFormToErrorState(_t('seller_common:call-reminder-modal.error.too-far-future'));
            return false;
        }
        clearErrorState();
        return true;
    }

    const setFormToErrorState = (message, disableResubmit= true) => {
        $(`#${domElements.modalId} .error-div`).html(message);
        $(`#${domElements.modalId} .error-div`).removeClass('d-none');
        $('#create-reminder').prop('disabled', disableResubmit);
    }

    const clearErrorState = () => {
        $(`#${domElements.modalId} .error-div`).html('');
        $(`#${domElements.modalId} .error-div`).addClass('d-none');
        $('#create-reminder').prop('disabled', false);
    }

    /**
     *
     * @param {string} date
     * @param {string} time
     * @returns {Date}
     */
    const getDateObjectFromDateAndTime = (date, time) => {
        let dtString = date + " " + time;
        return new Date(dtString.replace(/-/g, "/")); // Fix for Safari not liking hyphenated dates
    }


    const createReminder = (date, time) => {
        clearErrorState()
        if (validateDateAndTime()) {
            const dateTime = getDateObjectFromDateAndTime(date, time)
            barkApi(
                'reminders',
                {
                    type: "callback",
                    source: {type: 'project_response_action', id: state.projectResponseActionId},
                    trigger_at: moment(dateTime).utc().format('YYYY-MM-DD HH:mm:ss'),
                    notifications: ['email']
                },
                (res) => {
                    $(`#${domElements.modalId}`).modal('hide');
                    if (activityLog) {
                        setTimeout(() => {
                            activityLog.redraw();
                        }, 1000);
                    }
                    callReminderLogTrackingEvent('call_reminder - reminder_set', {
                        time_to_reminder: durationFromNowAsString(moment(date + " " + time).utc())
                    });
                },
                (error) => {
                    setFormToErrorState(_t('seller_common:call-reminder-modal.error.cant-create'), false)
                    bugsnagClientNotify('Failed to create reminder', error);
                },
                'POST',
            );
        }
	};

    const callReminderLogTrackingEvent = (eventName, data) => {
        barkTrackingLogEvent('seller-leads-dashboard-&-responses', eventName, {
            project_age: data?.projectCreated,
            primary_category: data?.categoryName,
            page: window.location.pathname,
            time_to_reminder: data?.time_to_reminder
        });
    };

    /**
     * format duration  to string for heap events
     * @param {moment.Moment} reminderTime
     * @param {moment.Moment} now
     */
    const durationFromNowAsString = (reminderTime, now = moment().utc() ) => {
        const duration = moment.duration(reminderTime.diff(now));

        //Get Days
        const days = Math.floor(duration.asDays()); // .asDays returns float but we are interested in full days only
        const daysFormatted = days ? (days + ' day' + (days>1 ? 's ' : '')): ''; // if no full days then do not display it at all

        //Get Hours
        const hours = duration.hours();
        const hoursFormatted = hours + ' hour' + (hours>1 ? 's' : '');

        //Get Minutes
        const minutes = duration.minutes();
        const minutesFormatted = minutes + ' min' + (minutes>1 ? 's ' : '');

        let durationAsString = [daysFormatted, hoursFormatted, minutesFormatted].join(', ');
        durationAsString = durationAsString.replace(/(^,)|(,$)/g, '').trim()

        return durationAsString;
    }

    return {
		show,
        bindActivityLogListeners
	};
}
